<div class="toggleButton toolbarLabel">
  <input type="checkbox" id="findMatchCase" tabindex="0" />
  <label for="findMatchCase" data-l10n-id="pdfjs-find-match-case-checkbox-label"></label>
</div>
